import debounce from 'lodash/debounce'
import * as React from 'react'
import { useDispatch } from 'hooks/use-redux'
import type { DropdownOption } from 'types/ui'
import {
  togglePlaylistFilter,
  updatePlaylistReportParams,
} from '@disco/state-management/actions/ReportActions'
import api from '@disco/api/server'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
type Props = {
  formKey: string
  disabled?: boolean
}

const getOptionsFromResponse = (results: Record<string, any>[]) => {
  const options = results?.map(writer => ({
    label: writer.name,
    value: writer.id.toString(),
  }))
  return [
    {
      label: 'All writers',
      value: '',
    },
    ...options,
  ]
}

const ReportWriter = ({ disabled, formKey }: Props): React.ReactNode => {
  const dispatch = useDispatch()
  // Track the full selected option (with label) locally
  // This is needed because Redux only stores the ID, but react-select async
  // needs the full option object to display the selected value
  const [selectedOption, setSelectedOption] =
    React.useState<DropdownOption | null>(null)

  const onChange = (option: DropdownOption) => {
    const value = option?.value || ''
    setSelectedOption(value === '' ? null : option)
    dispatch(
      value === ''
        ? togglePlaylistFilter(formKey, false)
        : updatePlaylistReportParams({
            [formKey]: value,
          }),
    )
  }

  const loadOptions = debounce((input, callback) => {
    ;(async () => {
      try {
        const { results } = await api.getWriters(input, 20)
        const options = getOptionsFromResponse(results)
        return callback(null, {
          options: options,
        })
      } catch {
        return callback(null, {
          options: [],
        })
      }
    })()
  }, 300)
  return (
    <CustomDropdown
      value={selectedOption}
      name="writer"
      multi={false}
      placeholder="Select writer"
      onChange={onChange}
      disabled={disabled}
      async
      loadOptions={loadOptions}
      cache
    />
  )
}

export default ReportWriter
